import { API_ENDPOINTS, withParams } from '../config/apis';
import { apiRequest } from '../api/client';

/** 백엔드 CertificateFontResponse와 동일 필드 */
export type CertificateFont = {
  id: number;
  name: string;
  fileUrl: string;
};

/** 폰트 파일 최대 크기 — 백엔드 CertificateFontServiceImpl.MAX_FILE_SIZE_BYTES(20MB)와 맞춘다. */
export const CERTIFICATE_FONT_MAX_FILE_SIZE = 20 * 1024 * 1024;
export const CERTIFICATE_FONT_NAME_MAX_LENGTH = 100;
export const CERTIFICATE_FONT_ACCEPT = '.ttf,.otf';

export const certificateFontService = {
  list: () =>
    apiRequest<{ fonts: CertificateFont[] }>(API_ENDPOINTS.certificateFontList).then(
      (res) => res.fonts
    ),

  // 백엔드는 multipart 필드 'name' + 'file' 을 받는다 (@ModelAttribute)
  create: (name: string, file: File) => {
    const form = new FormData();
    form.append('name', name);
    form.append('file', file);
    return apiRequest<CertificateFont, FormData>(API_ENDPOINTS.certificateFontCreate, {
      body: form,
    });
  },

  // 템플릿이 사용 중인 폰트는 서버가 400(CERTIFICATE_FONT_IN_USE)으로 거절한다
  delete: (id: number) =>
    apiRequest<void>(withParams(API_ENDPOINTS.certificateFontDelete, { certificateFontId: id })),
};
